/**
 * GroupData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleData } from './battle_data'
import type { CampData } from './camp_data'

/**
 * GroupData
 */
export interface GroupData {
  /** 群组ID */
  id?: string
  /** 群组类型(camp/battle) */
  type?: string
  /** 大本营数据（type=camp时） */
  camp?: CampData
  /** 对线群数据（type=battle时） */
  battle?: BattleData
}

/**
 * GroupData Schema
 */
export const GroupDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '群组ID',
      format: 'string',
      type: 'string',
      label: '群组ID',
    },
    type: {
      description: '群组类型(camp/battle)',
      format: 'cons.GroupType',
      type: 'string',
      label: '群组类型',
    },
    camp: {
      $ref: 'CampData',
      description: '大本营数据（type=camp时）',
      label: '大本营数据',
    },
    battle: {
      $ref: 'BattleData',
      description: '对线群数据（type=battle时）',
      label: '对线群数据',
    },
  },
  type: 'object',
}
